/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React, { useState } from "react";
import LoginPageMeta from "./LoginPageMeta";
import Layout from "../../../Layouts/Layout";
import Container from "../../../../components/Container/Container";
import AuthAction from "@/src/components/Auth/AuthAction";
import { Box, Typography } from "@mui/material";
import Card from "@mui/material/Card";
import { AuthActionType } from "@/src/types/AuthActionType";
import loginPageStyle from "@/src/containers/Pages/Generic/LoginPage/loginPageStyle";
import { translate } from "@/src/services/translations/translations";

export default function LoginPage() {
  const [authActionType, setAuthActionType] = useState<AuthActionType>("login");

  return (
    <Layout backgroundType={"landingpage"}>
      <LoginPageMeta />
      <Container variant={"xs"} sx={loginPageStyle.container}>
        <Card sx={loginPageStyle.card}>
          <Typography align={"center"} component={"h1"} variant={"h5"}>
            {translate("auth." + authActionType, {})}
          </Typography>
          <Box sx={{ paddingTop: "1.5rem" }}>
            <AuthAction actionType={authActionType} onActionTypeChange={setAuthActionType} />
          </Box>
        </Card>
      </Container>
    </Layout>
  );
}
